import React, { useId } from 'react'
import PropTypes from 'prop-types'

const CheckCircleFillIcon = React.forwardRef(function CheckCircleFillIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0ZM17.7 9.71L10.92 16.33L7.29 12.7C6.9 12.31 6.9 11.68 7.29 11.29C7.68 10.9 8.31 10.9 8.7 11.29L10.93 13.52L16.29 8.28C16.69 7.89 17.32 7.9 17.7 8.3C18.1 8.7 18.09 9.33 17.7 9.71Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

CheckCircleFillIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CheckCircleFillIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default CheckCircleFillIcon
